import {
  resolveFacetId,
  type FunnelbackFacetFilterFacet,
} from '../facet-filter';
import { facetIdsEqual } from '../../context/search-app/facet-id';
import {
  DEAKIN_FACULTY_FACET_ID,
  DEAKIN_TOPICS_FACET_ID,
  deakinFacultyLabel,
  deakinTopicLabel,
  facetValueToSlug,
} from '../../funnelback/deakin-config';

/** Human-readable label for a selected facet value (chip text). */
export function resolveFacetValueLabel(
  facetId: string,
  value: string,
  funnelbackFacets: unknown[],
): string {
  if (!value.trim()) {
    return '';
  }

  const facets = funnelbackFacets as FunnelbackFacetFilterFacet[];
  for (const facet of facets) {
    const resolvedId = resolveFacetId(facet);
    if (!resolvedId || !facetIdsEqual(resolvedId, facetId)) {
      continue;
    }
    const match = facet.allValues?.find((entry) =>
      facetValuesMatch(entry.data, value),
    );
    if (match?.label?.trim()) {
      return match.label.trim();
    }
    if (match?.data?.trim()) {
      return match.data.trim();
    }
  }

  if (facetIdsEqual(facetId, DEAKIN_TOPICS_FACET_ID)) {
    const label = deakinTopicLabel(value);
    if (label) {
      return label;
    }
  }
  if (facetIdsEqual(facetId, DEAKIN_FACULTY_FACET_ID)) {
    const label = deakinFacultyLabel(value);
    if (label) {
      return label;
    }
  }

  return value.trim();
}

export function facetValuesMatch(a: string, b: string): boolean {
  return (
    a === b || facetValueToSlug(a) === facetValueToSlug(b)
  );
}
